<table class="subwindow" plessTitleWindowSub [windowMovable]="false" [windowResizable]="false" [frontDispFlag]="false" cdkDrag [cdkDragConstrainPosition]="constrainPosition">
	<tr class="subwindow-title" cdkDragHandle>
		<th class="window-title-name">企画連絡承認</th>
	</tr>
	<tr class="subwindow-body">
		<td>
			<div class="contents-area">
				<div class="block-row">
					<div class="block-column" style="width: 47%;">
						<div class="column-list">
							<label class="list-input-title">受注コード</label>
							<div class="list-input-content">
								<input type="text" class="deliv-catalog" value="{{this.kymw1317Model.orderCode}}" readonly>
							</div>

							<label class="list-input-title">Pコード</label>
							<div class="list-input-content">
								<input type="text" class="pcode" value="{{this.kymw1317Model.pCode}}" readonly>
							</div>

							<label class="list-input-title">商品名</label>
							<div class="list-input-content">
								<input type="text" class="guide-goods-name" value="{{this.kymw1317Model.guideGoodsName}}" readonly>
							</div>

							<label class="list-input-title">規格名</label>
							<div class="list-input-content">
								<input type="text" class="guide-standard-name" value="{{this.kymw1317Model.guideStandardName}}" readonly>
							</div>
						</div>
					</div>

					<div class="element-column">
						<div class="element-column">
							<div class="column-list">
								<label class="list-input-title">アイテムコード</label>
								<div class="list-input-content" style="width: 8rem;">
									<select id="cmb_ItemCode" #cmb_ItemCode class="combo-box-required disabled-color-required" tabindex="0"
										[(ngModel)]="this.kymw1317Model.selectedItemCode">
										<ng-template ngFor let-item [ngForOf]="this.kymw1317Model.supplierInformationList">
											<option value="{{item.itemCode}}">{{item.itemCode}}</option>
										</ng-template>
									</select>
								</div>
							</div>

							<div class="block-row">
								<div class="column-list" style="width:305px">
									<label class="list-input-title">取引先</label>
									<div class="list-input-content">
										<input type="text" value="{{getSelectedSupplierInformation('orderClientName').orderClientName}}" readonly>
									</div>
								</div>

								<div class="column-list" style="width:305px">
									<label class="list-input-title">担当者</label>
									<div class="list-input-content">
										<input type="text" value="{{getSelectedSupplierInformation('kikakuRenrakuKakuninUserName').kikakuRenrakuKakuninUserName}}" readonly>
									</div>
								</div>

								<div class="column-list" style="width:305px">
									<label class="list-input-title">確認日</label>
									<div class="list-input-content">
										<input type="text" value="{{convertDateToYYYYMMDDString(getSelectedSupplierInformation('dataCreateDay').dataCreateDay)}}" readonly>
									</div>
								</div>
							</div>
						</div>

						<div class="block-row">
							<div class="element-column message-info">
								<label class="list-input-title">この商品についての伝言がありましたらご記入ください。</label>
								<app-text-area [(ngModel)]="getSelectedSupplierInformation('messageFromClient').messageFromClient"
									[displayCountField]="false" [maxChars]="200" [height]="70" [editable]="false">
								</app-text-area>
							</div>

							<div class="element-column message-info">
								<label class="list-input-title">掲載画像変更指示</label>
								<app-text-area
									[(ngModel)]="getSelectedSupplierInformation('displayImageChangeIndication').displayImageChangeIndication"
									[displayCountField]="false" [maxChars]="400" [height]="70" [editable]="false">
								</app-text-area>
							</div>

							<div class="element-column message-info">
								<label class="list-input-title">生協より</label>
								<app-not-null-text-area
									[(ngModel)]="getSelectedSupplierInformation('messageFromCoop').messageFromCoop"
									[allowMultiLine]="false" [displayCountField]="false"
									[disabled]="this.kymw1317Model.isDisabledMessageFromCoop"
									[restrict]="'[ -￮]'"
									[fullOnly]="true"
									[maxChars]="200" 
									>
								</app-not-null-text-area> 
							</div>
						</div>
					</div>
				</div>

				<div>
					<h2>変更項目一覧</h2>
					<div class="element-column">
						<wj-flex-grid #dtg_approvalColumnList id="dtg_approvalColumnList"
							[itemsSource]="this.kymw1317Model.approvalColumnList" [headersVisibility]="'Column'" [allowSorting]="false"
							sortableColumns="false" [allowDragging]="'None'" editable="true" [selectionMode]="'Row'" [isReadOnly]="true"
							[allowResizing]="'Columns'" [autoRowHeights]="true">
							<wj-flex-grid-column [header]="'承認担当'" [binding]="'approver'" [width]="100" [minWidth]="5"
								[isReadOnly]="true"></wj-flex-grid-column>
							<wj-flex-grid-column [header]="'アイテムコード'" [binding]="'itemCode'" [width]="120" [minWidth]="5"
								[isReadOnly]="true"></wj-flex-grid-column>
							<wj-flex-grid-column [header]="'P/I'" [binding]="'reflectUnit'" [width]="50" [minWidth]="5" [align]="'center'"
								[isReadOnly]="true"></wj-flex-grid-column>
							<wj-flex-grid-column [header]="'項目名'" [binding]="'columnName'" [width]="180" [minWidth]="5"
								[isReadOnly]="true"></wj-flex-grid-column>
							<wj-flex-grid-column [header]="'企画連絡時データ'" [binding]="'planContactData'" [width]="335" [minWidth]="5" [isReadOnly]="false">
								<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
									<div class="cell-word-break">{{cell.item.planContactData}}</div>
								</ng-template>
							</wj-flex-grid-column>
							<wj-flex-grid-column [header]="'取引先修正データ'" [binding]="'supplierFixData'" [width]="335" [minWidth]="5" [isReadOnly]="true">
								<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
									<div class="cell-word-break">{{cell.item.supplierFixData}}</div>
								</ng-template>
							</wj-flex-grid-column>
							<wj-flex-grid-column [header]="'現状データ'" [binding]="'current'" [width]="333" [minWidth]="5" [isReadOnly]="true">
								<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
									<div class="cell-word-break">{{cell.item.current}}</div>
								</ng-template>
							</wj-flex-grid-column>
							<wj-flex-grid-column [header]="'反映'" [binding]="'isReflect'" [width]="50" [minWidth]="5">
								<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
									<input type="checkbox" [tabindex]="-1" [(ngModel)]="cell.item.isReflect"
										[disabled]="cell.item.isDisabledReflect"
										(change)="changeReflectCheckbox($event.currentTarget,cell.item)"
										id="reflect_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"/>
								</ng-template>
							</wj-flex-grid-column>
							<wj-flex-grid-column [header]="'串刺'" [binding]="'isSkewer'" [width]="50" [minWidth]="5">
								<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
									<input type="checkbox" [tabindex]="-1" [(ngModel)]="cell.item.isSkewer"
										[disabled]="cell.item.isDisabledSkewer"
										id="skewer_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"/>
								</ng-template>
							</wj-flex-grid-column>
						</wj-flex-grid>

						<div class="column-list">
							<label class="list-input-title">ステータス</label>
							<div class="list-input-content">
								<input type="text" readonly [style.background-color]="this.kymw1317Model.kikakuRenrakuStatusBgColor"
									value="{{this.kymw1317Model.kikakuRenrakuStatusName}}" id="txt_status">
							</div>

							<label class="list-input-title">承認種別</label>
							<div class="list-input-content">
								<div>
									<label>
										<input type="checkbox" id="approvalType-buyer-input" tabindex="0"
											[(ngModel)]="this.kymw1317Model.buyerCheckboxVal" [disabled]=" this.kymw1317Model.isDisabledBuyerCheckbox"
											(change)="changeApprovalTypeCheckbox($event.currentTarget,'buyer')">
										<span for="approvalType-buyer-input" id="approvalType-buyer-label">バイヤー</span>
									</label>
									<label>
										<input type="checkbox" id="approvalType-editor-input" 	tabindex="0"
											[(ngModel)]="this.kymw1317Model.editorCheckboxVal"
											[disabled]="this.kymw1317Model.isDisabledEditorCheckbox"
											(change)="changeApprovalTypeCheckbox($event.currentTarget,'editor')">
										<span for="approvalType-editor-input" id="approvalType-editor-label">編集</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</td>
	</tr>

	<tfoot cdkDragHandle>
		<tr>
			<td>
				<div class="footer-buttons">
					<button id="btn_Set" class="btn-primary" (click)="clickApprovalButton()" 
						[tabindex]="0" [disabled]="this.kymw1317Model.isDisabledApprovalButton">承認</button>
				</div>
				<div class="window-title-close">
					<!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
					<button [tabindex]="0" (click)="onClickClose()"></button>
				</div>
			</td>
		</tr>
	</tfoot>
</table>
